import {GET, POST, PUT, reUrl} from '../../axiosconfig/axiosconfig'

export default {
    // 获取插件列表
    getPluginList: function (params) {
        return GET(reUrl + '/script/plugins/', params)
    },
    
    // 获取标签源插件列表 (筛选出激活的标签源插件)
    getTagSources: function (params) {
        const defaultParams = {
            plugin_type: 'tag_source',
            status: 'active'
        }
        return GET(reUrl + '/script/plugins/', {...defaultParams, ...params})
    },
    
    // 激活插件
    activatePlugin: function (id) {
        return POST(reUrl + `/script/plugins/${id}/activate/`)
    },
    
    // 停用插件
    deactivatePlugin: function (id) {
        return POST(reUrl + `/script/plugins/${id}/deactivate/`)
    },
    
    // 禁用插件(删除)
    disablePlugin: function (id) {
        return POST(reUrl + `/script/plugins/${id}/disabled/`)
    },
    
    // 获取插件统计
    getPluginStatistics: function (params) {
        return GET(reUrl + '/script/plugins/statistics/', params)
    },
    
    // 更新插件配置
    updatePluginConfig: function (pluginId, data) {
        return PUT(reUrl + `/script/plugins/${pluginId}/update_config/`, data)
    },
    
    // 上传插件文件 (新增)
    uploadPlugin: function (formData) {
        const config = {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        return POST(reUrl + '/script/plugins/upload_plugin/', formData, config)
    },
    
    // 下载插件模板 (新增)
    downloadTemplate: function (type) {
        return GET(reUrl + `/script/plugins/download_template/`, {type: type})
    },
    
    // 重新加载插件系统
    reloadPlugins: function () {
        return POST(reUrl + '/script/plugins/reload/')
    }
}